// Auto-generated file. Do not modify.
export const APP_VERSION = '3.1.2.142';
export const BUILD_NUMBER = 142;
export const VERSION = '3.1.2';
export const FULL_VERSION = '3.1.2.142';
export const GIT_HASH = '24ad524';
export const GIT_BRANCH = 'master';
export const BUILD_INFO = '3.1.2.142 (24ad524)';
export const RELEASE_NAME = '';
